<script>
export default {
  methods: {
    rebuildUserStylesheet (id, data) {
      function buildCSS (css) {
        const result = []
        css.forEach(entry => {
          const { key, value } = entry
          result.push(`${key}: ${value};`)
        })
        return result.join('\n')
      }

      let elExists = true
      let el = document.querySelector(`style#${id}`)
      if (!el) {
        el = document.createElement('style')
        el.id = id
        elExists = false
      }
      const { selector } = data
      const cssText = Object.entries(data).map(([key, entry]) => {
        if (key === 'selector') {
          return ''
        }
        const { selector: entrySelector = selector } = entry
        const css = entry.css()
        const str = `${entrySelector} { ${buildCSS(css)} }`
        return str
      })
      el.innerHTML = cssText.join('\n')
      if (!elExists) {
        document.head.appendChild(el)
      }
    }
  }
}
</script>
